export default "__VITE_ASSET__DfnwhEeB__"